import {
  checkIsValidPrams,
  checkValidUrl,
} from "../../../components/MultiInput/HttpInput/http-constant";
import { isOptionValid } from "../../../utils/canvasUtils";

export const botNodeCategories = {
    BASIC:"BASIC",
    INTERACTIVE:"INTERACTIVE",
    ACTIONS:"ACTIONS",
    REDIRECT:"REDIRECT"
}

export const botNoteCategoryLabel = {
  [botNodeCategories.BASIC]:"Basic",
  [botNodeCategories.INTERACTIVE]:"Interactive",
  [botNodeCategories.ACTIONS]:"Actions",
  [botNodeCategories.REDIRECT]:"Links"
}

export const botNoteCategoryList = [
  {
    label: botNoteCategoryLabel[botNodeCategories.BASIC],
    value: botNodeCategories.BASIC
   },
   {
    label: botNoteCategoryLabel[botNodeCategories.INTERACTIVE],
    value: botNodeCategories.INTERACTIVE
   },
   {
    label: botNoteCategoryLabel[botNodeCategories.ACTIONS],
    value: botNodeCategories.ACTIONS
   },
   {
    label: botNoteCategoryLabel[botNodeCategories.REDIRECT],
    value: botNodeCategories.REDIRECT
   }
]
export const nodeTypes = [
  {
    name: "Text",
    value: "text",
    icon: "/svgIcons/Bot builder icons/left-align-icon.svg",
    category: botNodeCategories.BASIC
  },
  {
    name: "Image",
    value: "image",
    icon: "/svgIcons/Bot builder icons/image-icon.svg",
    category: botNodeCategories.BASIC
  },
  {
    name: "Video",
    value: "video",
    icon: "/svgIcons/Bot builder icons/image-icon.svg",
    category: botNodeCategories.BASIC
  },
  {
    name: "Template",
    value: "template",
    icon: "/svgIcons/Bot builder icons/template.svg",
    category: botNodeCategories.INTERACTIVE
  },
  {
    name: "Pattern",
    value: "pattern",
    icon: "/svgIcons/Bot builder icons/left-align-icon.svg",
    category: botNodeCategories.BASIC
  },
  {
    name: "Quick Reply",
    value: "quick_reply",
    icon: "/svgIcons/Bot builder icons/quick-reply-icon.svg",
    category: botNodeCategories.INTERACTIVE
  },
  {
    name: "List",
    value: "list",
    icon: "/svgIcons/Bot builder icons/List.svg",
    category: botNodeCategories.INTERACTIVE
  },
  {
    name: "AI Agent",
    value: "aiAgent",
    icon: "/svgIcons/Bot builder icons/assign-agent.svg",
    category: botNodeCategories.ACTIONS
  },
  {
    name: "Assign Agent",
    value: "assignAgent",
    icon: "/svgIcons/Bot builder icons/assign-agent.svg",
    category: botNodeCategories.ACTIONS
  },
  {
    name: "Save Address",
    value: "addressInfo",
    icon: "/svgIcons/Bot builder icons/location.svg",
    category: botNodeCategories.ACTIONS
  },
  {
    name: "Share Catalog",
    value: "shareCatalog",
    icon: "/svgIcons/Bot builder icons/catalog.svg",
    category: botNodeCategories.ACTIONS
  },
  {
    name: "Campaign Products",
    value: "sendCampaignProducts",
    icon: "/svgIcons/Bot builder icons/catalog.svg",
    category: botNodeCategories.ACTIONS
  },
  {
    name: "Web Url",
    value: "http",
    icon: "/svgIcons/Bot builder icons/http-icon.svg",
    category: botNodeCategories.REDIRECT
  },
];

export const BOTFLOW_EDIT_KEY = "custom-botbuilder";
export const NON_EDIT_BOTFLOW_MESSAGE =
  "This botflow is not editable. Please contact Skalebot team.";

export const isTextNodeValid = (nodeData) => {
  let isValid = true;
  switch (nodeData.type) {
    case "text":
      if (nodeData.label?.trim() == "") {
        isValid = false;
      }
      break;
    case "image":
      if (nodeData.label?.trim() == "" || !nodeData?.image) {
        isValid = false;
      }
      break;
    case "video":
      if (nodeData.label?.trim() == "" || !nodeData?.video) {
        isValid = false;
      }
      break;
    case "pattern":
      if (nodeData.label?.trim() == "") {
        isValid = false;
      }
      break;
    case "aiAgent":
      if (!String(nodeData?.aiAgentId || "").trim()) {
        isValid = false;
      }
      break;
    default:
      //no actions
      break;
  }
  return isValid;
};

export const isQuickReplyNodeValid = (nodeData) => {
  let isValidPayload = isTextNodeValid(nodeData);
  let isValidOption = nodeData.options.length !== 0 && isOptionValid(nodeData.options);
  if (!isValidOption || !isValidPayload) {
    return false;
  } else {
    return true;
  }
};

export const islistNodeValid = (nodeData) => {
  let isBodyText = nodeData.body?.trim() !== "";
  let isListTitle = nodeData.lestHeading?.trim() !== "";
  let isGlobalButtonText = nodeData.globalButton?.trim() !== "";
  let isValidOption = isOptionValid(nodeData?.options || []);

  if (!isBodyText || !isGlobalButtonText || !isListTitle || !isValidOption) {
    return false;
  } else {
    return true;
  }
};

export const ishttpsNodeValid = (nodeData) => {
  const { params, headers, url, method } = nodeData;
  let isValidaPrams = checkIsValidPrams(params);
  let isValidHeaders = checkIsValidPrams(headers);
  let isValidUrl = checkValidUrl(url);
  let isMethod = method?.trim() !== "";

  if (!isValidHeaders || !isValidaPrams || !isValidUrl || !isMethod) {
    return false;
  } else {
    return true;
  }
};

export const isAllNodeValid = (nodeArr) => {
  let isValid = true;
  for (const node of nodeArr) {
    const { data, type } = node;
    switch (type) {
      case "text":
        isValid = isTextNodeValid(data);
        break;
      case "quick_reply":
        isValid = isQuickReplyNodeValid(data);

        break;
      case "list":
        isValid = islistNodeValid(data);
        break;
      case "http":
        isValid = ishttpsNodeValid(data);
        break;
      case "pattern":
        isValid = isTextNodeValid(data);
        break;
      default:
        break;
    }

    if (!isValid) return isValid;
  }

  return isValid;
};

export const interactiveNodes = ["quick_reply", "list", "template"];
